var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCalculationsLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30.914,
    viewBox: "0 0 24 30.914"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-calculations-link_svg__cls-7{fill:none}.kpmg-calculations-link_svg__cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round}.kpmg-calculations-link_svg__cls-3,.kpmg-calculations-link_svg__cls-4{fill:#fff}.kpmg-calculations-link_svg__cls-3{stroke-width:2px}.kpmg-calculations-link_svg__cls-6{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-calculations-link_svg__ICN_Calcule_Enabled",
    transform: "translate(-15 -498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-calculations-link_svg__Rectangle_215",
    "data-name": "Rectangle 215",
    transform: "translate(15 498)",
    strokeWidth: 1.6,
    stroke: "#fff",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-calculations-link_svg__cls-6",
    width: 24,
    height: 30.913,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-calculations-link_svg__cls-7",
    x: 0.8,
    y: 0.8,
    width: 22.4,
    height: 29.313,
    rx: 3.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-calculations-link_svg__Rectangle_216",
    "data-name": "Rectangle 216",
    width: 14.866,
    height: 5.945,
    rx: 1,
    transform: "translate(19.567 502.567)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    stroke: "#fff",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-calculations-link_svg__Rectangle_154",
    "data-name": "Rectangle 154",
    className: "kpmg-calculations-link_svg__cls-3",
    transform: "translate(19.479 511.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-calculations-link_svg__cls-6",
    width: 3.946,
    height: 3.717,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-calculations-link_svg__cls-7",
    d: "M1 1h1.946v1.717H1z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-calculations-link_svg__Rectangle_297",
    "data-name": "Rectangle 297",
    className: "kpmg-calculations-link_svg__cls-4",
    width: 3.946,
    height: 3.717,
    rx: 1,
    transform: "translate(19.479 516.272)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-calculations-link_svg__Rectangle_300",
    "data-name": "Rectangle 300",
    className: "kpmg-calculations-link_svg__cls-4",
    width: 3.946,
    height: 3.717,
    rx: 1,
    transform: "translate(19.479 521.272)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-calculations-link_svg__Rectangle_295",
    "data-name": "Rectangle 295",
    className: "kpmg-calculations-link_svg__cls-3",
    transform: "translate(24.837 511.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-calculations-link_svg__cls-6",
    width: 3.946,
    height: 3.717,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-calculations-link_svg__cls-7",
    d: "M1 1h1.946v1.717H1z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-calculations-link_svg__Rectangle_298",
    "data-name": "Rectangle 298",
    className: "kpmg-calculations-link_svg__cls-4",
    width: 3.946,
    height: 3.717,
    rx: 1,
    transform: "translate(24.837 516.272)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-calculations-link_svg__Rectangle_301",
    "data-name": "Rectangle 301",
    className: "kpmg-calculations-link_svg__cls-4",
    width: 3.946,
    height: 3.717,
    rx: 1,
    transform: "translate(24.837 521.272)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-calculations-link_svg__Rectangle_296",
    "data-name": "Rectangle 296",
    className: "kpmg-calculations-link_svg__cls-3",
    transform: "translate(30.195 511.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-calculations-link_svg__cls-6",
    width: 3.946,
    height: 3.717,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-calculations-link_svg__cls-7",
    d: "M1 1h1.946v1.717H1z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-calculations-link_svg__Rectangle_299",
    "data-name": "Rectangle 299",
    width: 3.946,
    height: 8.717,
    rx: 1,
    transform: "translate(30.195 516.272)",
    fill: "#30acec"
  }))));
}

export default SvgKpmgCalculationsLink;